import { Route, Routes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import UserLayout from "../layouts/UserLayout";
import Dashboard from "../pages/Dashboard";
import PatientManagement from "../pages/PatientManagement";
import AppointmentSlots from "../pages/AppointmentSlots";
import Reports from "../pages/Reports";
import Settings from "../pages/Settings";
import Login from "../pages/login";
import React from "react";
import BookingManagement from "../pages/BookingManagement";
import AgoraCall from "../pages/AgoraComponent";
import PatientAgoraCall from "../pages/AgoraComponent/Patient";
import DoctorManagement from "../pages/DoctorManagement";
import ProfilePage from "../pages/Profile";
import PrescriptionManagement from "../pages/PrescriptionManagement";
import DeliveryStatusUpdate from "../pages/DeliveryStatus/DeliveryStatusUpdate";
import BillingsPayment from "../pages/BillingsPayment";

// Public and protected layout-based route config
const RoutersList = [
  // {
  //   RouteLayout: <React.Fragment />,
  //   ProtectRoute: false,
  //   RouteList: [
  //     { path: "/delivery/:deliveryId", element: <DeliveryStatusUpdate /> },
  //   ]
  // },
  {
    RouteLayout: <UserLayout />,
    ProtectRoute: true,
    RouteList: [
      { path: "/", element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "patient-management", element: <PatientManagement /> },
      { path: "billings-payments", element: <BillingsPayment /> },
      { path: "appointment", element: <AppointmentSlots /> },
      { path: "booking-management", element: <BookingManagement /> },
      { path: "doctor-management", element: <DoctorManagement /> },
      { path: "prescription-management", element: <PrescriptionManagement /> },
      { path: "settings", element: <Settings /> },
      //{ path: "connect-call", element: <AgoraCall /> },
      //{ path: "connect-call-patient", element: <PatientAgoraCall /> },
      { path: "profile", element: <ProfilePage /> }
    ]
  },
  {
    RouteLayout: <React.Fragment />,
    ProtectRoute: true,
    RouteList: [
      { path: "connect-call", element: <AgoraCall /> },
    ]
  },
  {
    RouteLayout: <React.Fragment />,
    ProtectRoute: false,
    RouteList: [
      { path: "/login", element: <Login /> },
      { path: "/delivery-status/:deliveryId", element: <DeliveryStatusUpdate /> },
    ]
  },
];

export default RoutersList;
